import { FuelIssueVoucherStateTypes, FuelIssueVoucherActionTypes } from "./FuelIssueVoucher.type";
import { resetApiCallState } from "../Utils";

const INITIAL_STATE: FuelIssueVoucherStateTypes = {
  fetchAll: resetApiCallState([]),
  fetchOne: resetApiCallState({}),
};

const FuelIssueVoucherReducer = (
  state: FuelIssueVoucherStateTypes = INITIAL_STATE,
  action: any
): FuelIssueVoucherStateTypes => {
  switch (action.type) {
    case FuelIssueVoucherActionTypes.FETCH_ALL_FUEL_ISSUE_VOUCHER:
      return {
        ...state,
        fetchAll: {
          error: null,
          payload: [],
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelIssueVoucherActionTypes.FETCH_ALL_FUEL_ISSUE_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelIssueVoucherActionTypes.FETCH_ALL_FUEL_ISSUE_VOUCHER_FAILURE:
      return {
        ...state,
        fetchAll: {
          payload: [],
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelIssueVoucherActionTypes.FETCH_ALL_FUEL_ISSUE_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchAll: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    case FuelIssueVoucherActionTypes.FETCH_ONE_FUEL_ISSUE_VOUCHER:
      return {
        ...state,
        fetchOne: {
          error: null,
          payload: {},
          isPending: true,
          isSuccessful: false,
        },
      };
    case FuelIssueVoucherActionTypes.FETCH_ONE_FUEL_ISSUE_VOUCHER_RESET:
      return {
        ...state,
        fetchAll: resetApiCallState([]),
      };
    case FuelIssueVoucherActionTypes.FETCH_ONE_FUEL_ISSUE_VOUCHER_FAILURE:
      return {
        ...state,
        fetchOne: {
          payload: {},
          isPending: false,
          isSuccessful: false,
          error: action.payload,
        },
      };
    case FuelIssueVoucherActionTypes.FETCH_ONE_FUEL_ISSUE_VOUCHER_SUCCESS:
      return {
        ...state,
        fetchOne: {
          error: null,
          isPending: false,
          isSuccessful: true,
          payload: action.payload,
        },
      };

    default:
      return state;
  }
};

export default FuelIssueVoucherReducer;
